import { render, staticRenderFns } from "./CollegePurchaseDepartmentHodClassStudent.vue?vue&type=template&id=e3a95b3e"
import script from "./CollegePurchaseDepartmentHodClassStudent.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseDepartmentHodClassStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports